import React from "react";
import MultiRowCarousel from "../MultiRowsCarousel";
import leftArrow from "../../../../assets/shapes_svg/ambition/left-arrow-green.svg";
import rightArrow from "../../../../assets/shapes_svg/ambition/right-arrow-green.svg";
import "./index.css";

export const CompanyAmbition = () => {
  const allSections = [
    { name: "History" },
    { name: "Mission" },
    { name: "Vision" },
    { name: "Values" },
    { name: "We provide/produce" },
    { name: "Your Clients & Customers" },
    { name: "Baseline" },
  ];

  const ButtonGroup = ({ onNext, onPrevious }) => {
    return (
      <div className="carousel-navigation">
        <img
          src={leftArrow}
          onClick={onPrevious}
          alt="Previous"
          className="ambition-nav-button"
        />
        <img
          src={rightArrow}
          onClick={onNext}
          alt="Next"
          className="ambition-nav-button"
        />
      </div>
    );
  };

  const renderItem = (item) => (
    <div className="company-ambition-item">
      <h4>{item.name}</h4>
    </div>
  );

  return (
    <div className="company-ambition-container">
      <MultiRowCarousel
        items={allSections}
        rowsPerSlide={2}
        itemsPerRow={3}
        CustomButtonGroup={ButtonGroup}
        renderItem={renderItem}
      />
    </div>
  );
};
